import { Flex, Text, Button } from "@chakra-ui/react";
import { AddIcon } from "@chakra-ui/icons";
import { GetLayout } from "components/get-layout";
import {
  PageContent,
  UsuarioBanco
} from "components/usuarios-bancos-components/page";
import { useApplicationContext } from "contexts/ApplicationContext";
import { checkPermission, RoutePermissionFunction } from "router-manager/parts";
import { isUserGerente } from "utils/is-gerente";
import { useEffect, useState } from "react";
import api from "api/api";
import { Toast } from "components/toast";
import { useFilterEmpresa } from "components/usuarios-bancos-components/utils";
import { openModalUsuariosBancos } from "components/usuarios-bancos-components/usuarios-bancos-modal";

const UsuariosBancos = () => {
  const { user } = useApplicationContext();
  const isGerente = isUserGerente(user);
  const [usuariosBancosList, setUsuariosBancosList] = useState<UsuarioBanco[]>(
    []
  );
  const [loading, setLoading] = useState(false);

  const loadUsuariosBanco = async ({ customerId }: { customerId?: number }) => {
    setLoading(true);
    try {
      let response = await api.get(`/usuarios-bancos`, {
        params: { customer_id: customerId }
      });
      setUsuariosBancosList(response.data);
    } catch (error) {
      Toast({
        title: "Erro ao buscar lista de Usuario Banco",
        status: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  let { empresas, loadingEmpresas, onChangeEmpresa, selectedEmpresa } =
    useFilterEmpresa({
      onChange: (customerId) => {
        loadUsuariosBanco({ customerId });
      },
      initialValue: user.userData.customerId
    });

  useEffect(() => {
    loadUsuariosBanco({
      customerId: isGerente ? user.userData.customerId : undefined
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isGerente, user.userData.customerId]);

  return (
    <GetLayout
      title="Usuários Bancos"
      rightContent={
        isGerente &&
        user.userData.customerChildrenInheritUsersBancos !== true ? null : (
          <Button
            leftIcon={<AddIcon w="13px" h="13px" />}
            onClick={() =>
              openModalUsuariosBancos({
                customerId:
                  isGerente &&
                  user.userData.customerChildrenInheritUsersBancos !== true
                    ? selectedEmpresa
                    : undefined
              })
            }
          >
            Adicionar Usuário Banco
          </Button>
        )
      }
    >
      <PageContent
        usuariosBancosList={usuariosBancosList}
        setUsuariosBancosList={setUsuariosBancosList}
        loading={loading}
        setLoading={setLoading}
        loadUsuariosBanco={loadUsuariosBanco}
        empresas={empresas}
        loadingEmpresas={loadingEmpresas}
        onChangeEmpresa={onChangeEmpresa}
        selectedEmpresa={selectedEmpresa}
      />
    </GetLayout>
  );
};

export default UsuariosBancos;

export const setRoutePermissions: RoutePermissionFunction = (route) => {
  route.addCustomPermission((user) =>
    checkPermission(
      user,
      !!user?.userData?.parentCustomerId &&
        user?.userData?.useParentUsersBancos === true
        ? [
            "SUPER",
            "REGIONAL",
            "COMERCIAL",
            "PARCEIRO_GERENTE_ESTRATEGICO",
            "PARCEIRO_GERENTE_VAREJO"
          ]
        : [
            "SUPER",
            "REGIONAL",
            "COMERCIAL",
            "PARCEIRO_GERENTE_ESTRATEGICO",
            "PARCEIRO_GERENTE_VAREJO",
            "PARCEIRO_MASTER"
          ],
      ["COMERCIAL"]
    )
  );
};
